import { render, staticRenderFns } from "./AreaSelect.vue?vue&type=template&id=7a75448a&scoped=true&"
import script from "./AreaSelect.vue?vue&type=script&lang=js&"
export * from "./AreaSelect.vue?vue&type=script&lang=js&"
import style0 from "./AreaSelect.vue?vue&type=style&index=0&id=7a75448a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a75448a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\shop-admin-vue\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a75448a')) {
      api.createRecord('7a75448a', component.options)
    } else {
      api.reload('7a75448a', component.options)
    }
    module.hot.accept("./AreaSelect.vue?vue&type=template&id=7a75448a&scoped=true&", function () {
      api.rerender('7a75448a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/fwpt/basic/area/AreaSelect.vue"
export default component.exports